import { Component, OnInit } from '@angular/core';
import { Breadcrumb, GenerateTableColumn, GenerateTablePagination } from 'src/app/shared/components';
import { BeneficiariaService } from '../beneficiaria.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ContratoService } from 'src/app/contrato';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Beneficiaria } from '../beneficiaria.model';
import { catchErr } from 'src/app/shared/utils';

@Component({
    selector: 'app-view-beneficiaria-coligada',
    templateUrl: './view-beneficiaria-coligada.component.html',
    standalone: false
})
export class ViewBeneficiariaColigadaComponent implements OnInit{

    loading = true;
    breadcrumb: Breadcrumb[] = [
      { label: 'Início' },
      { label: 'Configurações' },
    ]
  
    dataSource: Beneficiaria[];
    pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 }
    columns: GenerateTableColumn[] = [
        { header: 'CNPJ', attr: 'cnpj' },
        { header: 'Nome', attr: 'nome' }, 
        {
          tdClass: 'td-w-auto',
          btnProps: { label: 'Remover', color: 'accent' },
          click: {action: (rowData: any) => this.removerColigada(rowData)}
        },      
    ]

    constructor(
      public beneficiariaService: BeneficiariaService,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private snackBar: MatSnackBar
    ) { }
  
    ngOnInit() {
      this.loading = true;      
      this.beneficiariaService.getAll<Beneficiaria>().subscribe({
          next: (res) => this.dataSource = res.data.filter(b => b.coligadaNovacap),
          error: (err) => catchErr(err, this.snackBar)
      }).add(() => this.loading = false);
      
    }

    removerColigada(beneficiaria: Beneficiaria) {
      this.loading = true;
      this.beneficiariaService.removeColigada(beneficiaria.id).subscribe({
        next: () => {
          this.snackBar.open('Coligada removida com sucesso!', 'Fechar', { duration: 3000 });
          this.dataSource = this.dataSource.filter(b => b.id !== beneficiaria.id);
        },
        error: (err: any) => catchErr(err, this.snackBar)
      }).add(() => this.loading = false);
    }
}
